export const TRAILERS_IMPORT_TEMPLATE_PATH =
  '/samples/trailers-import-template.csv';
export const TRAILERS_IMPORT_TEMPLATE_FILENAME =
  'trailers-import-template.csv';
